import { IIconProps } from './add';

export const IcoPrivateStudy: React.FC<IIconProps> = ({ cy, style }) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoPrivateStudy${cy}`}
    style={style}
  >
    <path
      d="M10.0001 4.66667H9.33341V3.33333C9.33341 1.49333 7.84008 0 6.00008 0C4.16008 0 2.66675 1.49333 2.66675 3.33333V4.66667H2.00008C1.26675 4.66667 0.666748 5.26667 0.666748 6V12.6667C0.666748 13.4 1.26675 14 2.00008 14H10.0001C10.7334 14 11.3334 13.4 11.3334 12.6667V6C11.3334 5.26667 10.7334 4.66667 10.0001 4.66667ZM6.00008 10.6667C5.26675 10.6667 4.66675 10.0667 4.66675 9.33333C4.66675 8.6 5.26675 8 6.00008 8C6.73341 8 7.33341 8.6 7.33341 9.33333C7.33341 10.0667 6.73341 10.6667 6.00008 10.6667ZM8.06675 4.66667H3.93341V3.33333C3.93341 2.19333 4.86008 1.26667 6.00008 1.26667C7.14008 1.26667 8.06675 2.19333 8.06675 3.33333V4.66667Z"
      fill="#515252"
    />
  </svg>
);
